import React from 'react'
import Button from '@Components/Buttons/Button'
import MlcTooltip from '@Components/Tooltips/MlcTooltip'

interface ExportButtonProps {
    loading: boolean
    setSidebarIsOpen(b: boolean): void
    disabled?: boolean
}

const tooltipId = 'export-non-sort-filters'

const RegistrationHistoryExportButton = ({ loading, setSidebarIsOpen, disabled }: ExportButtonProps) => (
    <>
        <span data-tooltip-id={disabled ? tooltipId : undefined}>
            <Button
                submitType="button"
                mainColor
                type="secondary"
                className="export-search-button"
                disabled={loading || disabled}
                onClick={() => setSidebarIsOpen(true)}
            >
                Export
            </Button>
        </span>
        <MlcTooltip id={tooltipId} place="top-start" variant="info">
            <span>
                <strong>Clear filters to export.</strong> Exports aren’t available when filters are applied
            </span>
        </MlcTooltip>
    </>
)

export default RegistrationHistoryExportButton
